<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{title}}</div>
      <div class="content-wrap">
        <div class="minHeiWrap synopsis">简介: <span v-html="synopsis"></span></div>
        <div class="minHeiWrap createBy">发布单位: <span>{{publishingUnit}}</span></div>
        <div class="minHeiWrap createTime">发布时间: <span>{{publishingDate}}</span></div>
        <div class="minHeiWrap implementationTime">实施时间: <span>{{implementationTime}}</span></div>
        <div class="minHeiWrap">链接/全文: <span class="link" @click="newBlackClick(link)">{{link}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import {getPolicyDetail} from "../../../api/InformationNote";
import { getCurrentCrumb } from '@/utils/crumb.js'
import Breadcrumb from '../../../components/common/Breadcrumb'

export default {
  data() {
    return {
      crumbOptions: [], //页面路径跳转展示
      title: '',
      synopsis: '', // 简介
      publishingUnit: '', // 发布单位
      publishingDate: '', // 发布时间
      implementationTime: '', // 实施时间
      link: '' // 链接/全文
    }
  },
  components: {
    Breadcrumb
  },
  methods: {
    // 页面刷新
    async initializeOrRefresh() {
      try {
        const { code, data } = await getPolicyDetail(this.$route.query.id)
        if (code === 200) {
          this.title = data.title
          this.synopsis = data.synopsis
          this.publishingUnit = data.publishingUnit
          this.publishingDate = data.publishingDate
          this.implementationTime = data.implementationTime
          this.link = data.link
        }
      } catch (e) {
        console.log(e, 'hhh')
        // eslint-disable-next-line no-empty
      } finally {}

    },
    // 链接跳转
    newBlackClick(link) {
      console.log('http://' + link, 'link')
      if (link.indexOf('http://') !== -1 || link.indexOf('https://') !== -1) {
        window.open(link, '_target')
      } else {
        window.open('https://' + link, '_blank')
      }
    },
    // 页面路径跳转
    settingCrumb () {
      const { path } = this.$route
      this.crumbOptions = getCurrentCrumb(path)
    },
  },
  mounted() {
    this.initializeOrRefresh()
    this.settingCrumb()
  }
}
</script>
<style lang="scss" scoped>
.content-wrap {
  //display: flex;
  //align-items: center;
  .minHeiWrap {
    margin-bottom: 20px;
    .link {
      color: #00abf3;
      cursor: pointer;
    }
  }
}

</style>
